'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; // Lib


var _reactDnd = require('react-dnd');

var _reactDndHtml5Backend = require('react-dnd-html5-backend');

var handleFileDrop = function handleFileDrop(props, monitor, component) {
    var file = monitor.getItem().files && monitor.getItem().files[0];
    if (file && props.uploadImage) {
        props.uploadImage(file);
    }
};

var defaultDropSpec = {
    drop: handleFileDrop
};

var defaultDropCollect = function defaultDropCollect(connector, monitor) {
    return {
        imageConnectDropTarget: connector.dropTarget(),
        imageIsHovered: monitor.canDrop() && monitor.isOver(),
        imageCanDrop: monitor.canDrop()
    };
};

exports.default = function (customSpec, customCollect) {
    var collect = customCollect || defaultDropCollect;
    var spec = _extends({}, defaultDropSpec, customSpec);

    return (0, _reactDnd.DropTarget)(_reactDndHtml5Backend.NativeTypes.FILE, spec, collect);
};


//////////////////
// WEBPACK FOOTER
// ./src/client/components/tools/images/imageFileDropTargetDecorator.js
// module id = 718
// module chunks = 0